import NewRepositoryDialog from './Container'
export default NewRepositoryDialog


// WEBPACK FOOTER //
// ./src/pages/RepositorySelect/NewRepositoryDialog/index.js